import React from 'react';
import { ValidatorComponent } from 'react-form-validator-core';

import TextField from '../../artzu-ui/src/TextField';

class NewMileage extends ValidatorComponent {
  render() {
    const { floatingLabelText = '', onChange = () => {}, name = '', value = '', inverted = false } = this.props;
    const { isValid } = this.state;

    return (
      <div className="">
        <TextField
          error={!isValid && this.getErrorMessage()}
          heading={floatingLabelText}
          name={name}
          value={value}
          width="100%"
          inverted={inverted}
          onChange={onChange}
          style={{ 'font-size': '16px', 'padding-top': '10px' }}
          placeholder="Enter the current odometer reading"
          // onChange={event =>
          //   changeState('reported_mileage', event.target.value)
          // }
        />
        <p className="error-text">{this.props.error}</p>
      </div>
    );
  }
}

export default NewMileage;



// WEBPACK FOOTER //
// ./src/components/Report/NewMileage.js